var _path, _path2;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFaq(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    preserveAspectRatio: "xMidYMid meet"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 3C0 1.89543 0.895431 1 2 1H9C10.1046 1 11 1.89543 11 3V7C11 8.10457 10.1046 9 9 9H7L4 12V9H2C0.895431 9 0 8.10457 0 7V3Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M13 5V7C13 9.20914 11.2091 11 9 11H7.82843L6.06173 12.7667C6.34154 12.9156 6.66091 13 7 13H9L12 16V13H14C15.1046 13 16 12.1046 16 11V7C16 5.89543 15.1046 5 14 5H13Z",
    fill: "currentColor"
  })));
}

export default SvgFaq;